import React, { FC, useEffect } from 'react';
import { Col, Row, Skeleton } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getMonitorSalesSummaryModel } from 'app/store/reducers/monitorSales.reducer';
import { IMonitorSalesParams } from 'entities/MonitorSales/MonitorSales.models';
import { SummaryRow } from 'entities/MonitorSales/components/SummaryRow';
import { SummaryTrendRow } from 'entities/MonitorSales/components/SummaryTrendRow';

interface IComponentProps {
  params?: IMonitorSalesParams;
  dateRange: string;
}

export const SalesSummaryBlock: FC<IComponentProps> = ({ params, dateRange }) => {
  const dispatch = useAppDispatch();
  const { monitorSalesSummaryModel, monitorSalesSummaryModelLoading } = useAppSelector((state) => state.monitorSales);
  const salesSummaryData = monitorSalesSummaryModel;

  useEffect(() => {
    dispatch(getMonitorSalesSummaryModel(params));
  }, [params?.storeCode, params?.week]);

  return (
    <div className="ms-block">
      <div className="ms__header">
        <span className="ff-medium fs-xs">{dateRange}</span>
        <WarningCircle />
      </div>

      <div className="ms__body">
        {monitorSalesSummaryModelLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <Row gutter={36}>
            <Col span={24} xxl={16}>
              <Row align="middle" gutter={20} className="mb-4">
                <Col span={18} className="ff-medium">
                  Targets
                </Col>
                <Col span={3} className="ff-medium t-align-e">
                  vs LP
                </Col>
                <Col span={3} className="ff-medium t-align-e">
                  vs LY
                </Col>
              </Row>

              <SummaryRow label="Sales" metric={salesSummaryData?.sales} />
              <SummaryRow label="TC" metric={salesSummaryData?.transactionCount} />
              <SummaryRow label="AC" metric={salesSummaryData?.averageCheck} />
              <SummaryRow label="ADS" metric={salesSummaryData?.averageDailySales} />
            </Col>

            <Col span={24} xxl={8}>
              <Row align="middle" gutter={20} className="mb-4">
                <Col className="ff-medium t-align-e">Trend</Col>
              </Row>

              <SummaryTrendRow data={salesSummaryData?.sales.trend} />
              <SummaryTrendRow data={salesSummaryData?.transactionCount.trend} />
              <SummaryTrendRow data={salesSummaryData?.averageCheck.trend} />
              <SummaryTrendRow data={salesSummaryData?.averageDailySales.trend} />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};
